import { Cache } from "memory-cache";
import { CorporationBlueprintEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationBlueprintEntity(item_id: number): Promise<CorporationBlueprintEntity | null> {
  let entity: any = await cache.get(item_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationBlueprintEntity(corporationBlueprint: CorporationBlueprintEntity) {
  cache.put(corporationBlueprint.props.item_id.toString(), corporationBlueprint, 60 * 60 * 1000 /* 1 hour */);
}
